import React from "react";
import Transfer from "./Transfer";

// Alias wrapper for Transfer to match route structure requirements
const TransferPlayer = () => {
  return <Transfer />;
};

export default TransferPlayer;
